import { render } from "./Home.vue?vue&type=template&id=59e112d4&scoped=true&lang=pug"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-59e112d4"

export default script